////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> pedidos_loja/?loja=               //
//                                                //
//  PÁGINA EXCLUSIVA PARA FRANQUEADOS PARA        //
//  GERENCIAR OS PEDIDOS DA LOJA COM FILTROS.     //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
////////////////////////////////////////////////////  



import React, {useState, useEffect} from "react"

import ContinuarComprando from  '../components/continuar_comprando';
import PrecoPictureQuantidadeFranqueado from  '../components/preco_picture_quantidade_franqueado';

import api from "../services/api";


function PedidosLoja() {
  
  // ESTADOS DEFINIDOS
    // 'pedidos' = LISTA DE PEDIDOS DA LOJA  
    // 'statusFiltros' = FILTROS DE STATUS ATIVOS
    // 'mostrarTodos' = BOOLEAN PARA MOSTRAR TODOS OS STATUS
    // 'produtos' = PRODUTOS DE CADA PEDIDO
    // 'pedidosExpandidos' = CONTROLA QUAIS PEDIDOS ESTÃO EXPANDIDOS

  let [pedidos, setPedidos] = useState([])
  let [statusFiltros, setStatusFiltros] = useState(['aguardando'])
  let [mostrarTodos, setMostrarTodos] = useState(false)
  let [modalAberta, setModalAberta] = useState(false)
  let [pedidoSelecionado, setPedidoSelecionado] = useState(null)
  let [produtosPedido, setProdutosPedido] = useState([])
  let [carregandoProdutos, setCarregandoProdutos] = useState(false)


  if(!sessionStorage['login']){  // CASO NÃO ESTIVER LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']  // REDIRECIONA DE VOLTA PARA A HOME     
  }    

  useEffect(() => {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/pedidos_loja/?loja=')
    
    async function inicializar() {
      if(sessionStorage['login'].includes('/')){  // VERIFICA SE O USUÁRIO ESTÁ LOGADO COMO FRANQUEADO

        var params = window.location.search 
        var urlparams = new URLSearchParams(params)
        var loja = urlparams.get('loja')
        
        if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
          window.location.href = '/pedidos_loja/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION      
        }
        
        var login = await api.post('verificar_login',{  // VERIFICA NO DB SE A LOJA CORRESPONDE AO TOKEN
          "id_loja": sessionStorage['loja'],
          "login": sessionStorage['login']
        }).then((response) => {
          return response
        })    
        
        if(!login['data']['login']){  // SE NÃO CORRESPONDER
          sessionStorage['loja'] = login['data']['id']  // TROCA A LOJA DA SESSION
          window.location.href = '/pedidos_loja/?loja='+ login['data']['id']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
        } 

      }
      else{  // CASO O USUÁRIO NÃO ESTEJA LOGADO COMO FRANQUEADO
        if(window.location.pathname != '/pedidos_loja'){
          window.location.href = '/?id=' + sessionStorage['loja']  // REDIRECIONA DE VOLTA PARA A HOME
        }
      }

      search_pedidos()  // CHAMA A FUNÇÃO DE BUSCAR OS PEDIDOS
    }
    
    inicializar()
  }, [statusFiltros]) // RECARREGA QUANDO OS FILTROS MUDAM

  async function search_pedidos(){  // FUNÇÃO QUE BUSCA OS PEDIDOS COM FILTROS
    // FUNÇÃO CHAMADA NO ONLOAD DESTA PÁGINA E QUANDO FILTROS MUDAM

    var id_loja = sessionStorage['loja']  // DEFINE A LOJA
    var query_start = 0  // INICIA A SUBQUERY EM ZERO
    var query_end = 100  // BUSCA ATÉ 100 PEDIDOS POR VEZ

    var filtros_ativos = mostrarTodos ? ['aguardando', 'concluido', 'cancelado'] : statusFiltros

    var resp = await api.post('buscar_pedidos_loja_filtrados',{  // BUSCA NO DB OS PEDIDOS DA LOJA COM FILTROS
      "id_loja": id_loja,
      "query_start": query_start,
      "query_end": query_end,
      "status_filtros": filtros_ativos
    }).then((response) => {
      return response
    })
    // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
      // 'data' -> LISTA COM 4 POSIÇÕES PARA CADA PEDIDO
        // 1a POSIÇÃO -> STRING COM O NOME DO CLIENTE
        // 2a POSIÇÃO -> DATA DO PEDIDO
        // 3a POSIÇÃO -> STRING COM ID DO PEDIDO
        // 4a POSIÇÃO -> STRING COM STATUS DO PEDIDO
    
    if (resp.data && resp.data.data) {
      setPedidos(resp.data.data)  // DEFINE O ESTADO COM AS INFORMAÇÕES
    } else {
      setPedidos([])
    }
  }

  function alterarFiltroStatus(status) {
    // FUNÇÃO PARA ALTERAR OS FILTROS DE STATUS
    setMostrarTodos(false)
    
    if (statusFiltros.includes(status)) {
      // Remove o status se já estiver selecionado
      setStatusFiltros(statusFiltros.filter(s => s !== status))
    } else {
      // Adiciona o status se não estiver selecionado
      setStatusFiltros([...statusFiltros, status])
    }
  }

  function mostrarTodosStatus() {
    // FUNÇÃO PARA MOSTRAR TODOS OS STATUS
    setMostrarTodos(!mostrarTodos)
    if (!mostrarTodos) {
      setStatusFiltros(['aguardando', 'concluido', 'cancelado'])
    } else {
      setStatusFiltros(['aguardando'])
    }
  }

  async function atualizarStatusPedido(pedidoId, novoStatus) {
    // FUNÇÃO PARA ATUALIZAR O STATUS DE UM PEDIDO
    
    var resp = await api.post('atualizar_status_pedido', {
      "pedido_id": pedidoId,
      "status": novoStatus
    }).then((response) => {
      return response
    })

    if (resp.data && resp.data.success) {
      // ATUALIZA A LISTA DE PEDIDOS APÓS ALTERAÇÃO
      search_pedidos()
    } else {
      alert('Erro ao atualizar status do pedido: ' + (resp.data?.message || 'Erro desconhecido'))
    }
  }

  function getStatusColor(status) {
    // FUNÇÃO PARA RETORNAR COR DO STATUS
    switch(status) {
      case 'aguardando': return 'text-warning'
      case 'concluido': return 'text-success'
      case 'cancelado': return 'text-danger'
      default: return 'text-secondary'
    }
  }

  function getStatusLabel(status) {
    // FUNÇÃO PARA RETORNAR LABEL DO STATUS
    switch(status) {
      case 'aguardando': return 'Aguardando'
      case 'concluido': return 'Concluído'
      case 'cancelado': return 'Cancelado'
      default: return status
    }
  }

  async function abrirModalProdutos(pedidoId) {
    // FUNÇÃO PARA ABRIR MODAL E BUSCAR PRODUTOS DO PEDIDO
    setPedidoSelecionado(pedidoId)
    setModalAberta(true)
    setCarregandoProdutos(true)
    setProdutosPedido([])

    try {
      var resp = await api.post('buscar_produtos_pedido', {
        "pedido_id": pedidoId
      })

      if (resp.data && resp.data.success) {
        setProdutosPedido(resp.data.produtos)
      } else {
        alert('Erro ao carregar produtos: ' + (resp.data?.message || 'Erro desconhecido'))
      }
    } catch (error) {
      alert('Erro ao carregar produtos do pedido')
      console.error(error)
    } finally {
      setCarregandoProdutos(false)
    }
  }

  function fecharModal() {
    // FUNÇÃO PARA FECHAR MODAL
    setModalAberta(false)
    setPedidoSelecionado(null)
    setProdutosPedido([])
  }

  // RENDERIZA A PÁGINA
  return (
    <div>
      <div>
        <ContinuarComprando />
      </div>

      <div id="todos_os_pedidos" class="custom-container">
        
        {/* FILTROS DE STATUS */}
        <div class="card-login p-3 mb-4">
          <div class="montserrat verde bold mb-3">Filtros:</div>
          
          <div class="d-flex flex-wrap gap-2 mb-3">
            <label class="d-flex align-items-center">
              <input 
                type="checkbox" 
                checked={statusFiltros.includes('aguardando')}
                onChange={() => alterarFiltroStatus('aguardando')}
                class="mr-2"
              />
              <span class="montserrat text-warning">Aguardando</span>
            </label>
            
            <label class="d-flex align-items-center ml-3">
              <input 
                type="checkbox" 
                checked={statusFiltros.includes('concluido')}
                onChange={() => alterarFiltroStatus('concluido')}
                class="mr-2"
              />
              <span class="montserrat text-success">Concluído</span>
            </label>
            
            <label class="d-flex align-items-center ml-3">
              <input 
                type="checkbox" 
                checked={statusFiltros.includes('cancelado')}
                onChange={() => alterarFiltroStatus('cancelado')}
                class="mr-2"
              />
              <span class="montserrat text-danger">Cancelado</span>
            </label>
          </div>

          <button 
            onClick={mostrarTodosStatus} 
            class={`btn btn-sm ${mostrarTodos ? 'btn-secondary' : 'btn-outline-secondary'}`}
          >
            {mostrarTodos ? 'Mostrar apenas aguardando' : 'Mostrar todos'}
          </button>
        </div>

        {/* LISTA DE PEDIDOS */}
        <div class='mb-5'>
          {pedidos.length === 0 ? (
            <div class="card-login p-4 text-center">
              <div class="montserrat">Nenhum pedido encontrado com os filtros selecionados.</div>
            </div>
          ) : (
            pedidos.map((pedido) => (
              <div class='my-3 mx-0 card-login p-3 w-100 border-gray' key={pedido[2]}>
                
                <div class="row">
                  <div class="col-md-8">
                    <div class="montserrat verde bold">Pedido:</div>
                    <div class="montserrat mb-2">{pedido[2]}</div>

                    <div class="montserrat verde bold">Cliente:</div>
                    <div class="montserrat mb-2">{pedido[0]}</div>

                    <div class="montserrat verde bold">Data:</div>
                    <div class="montserrat mb-2">{new Date(pedido[1]).toLocaleDateString('pt-BR')}</div>
                  </div>

                  <div class="col-md-4">
                    <div class="montserrat verde bold">Status:</div>
                    <div class={`montserrat bold mb-3 ${getStatusColor(pedido[3])}`}>
                      {getStatusLabel(pedido[3])}
                    </div>

                    {/* BOTÕES PARA ALTERAR STATUS */}
                    <div class="d-flex flex-column gap-1">
                      {pedido[3] !== 'aguardando' && (
                        <button 
                          onClick={() => atualizarStatusPedido(pedido[2], 'aguardando')}
                          class="btn btn-warning btn-sm"
                        >
                          Marcar como Aguardando
                        </button>
                      )}
                      
                      {pedido[3] !== 'concluido' && (
                        <button 
                          onClick={() => atualizarStatusPedido(pedido[2], 'concluido')}
                          class="btn btn-success btn-sm"
                        >
                          Marcar como Concluído
                        </button>
                      )}
                      
                      {pedido[3] !== 'cancelado' && (
                        <button 
                          onClick={() => atualizarStatusPedido(pedido[2], 'cancelado')}
                          class="btn btn-danger btn-sm"
                        >
                          Cancelar Pedido
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* BOTÃO PARA VER PRODUTOS EM MODAL */}
                <div class="row mt-3">
                  <div class="col-12">
                    <button 
                      onClick={() => abrirModalProdutos(pedido[2])}
                      class="btn btn-info btn-sm"
                    >
                      Ver Produtos
                    </button>
                  </div>
                </div>

              </div>
            ))
          )}
        </div>
      </div>

      {/* MODAL PARA EXIBIR PRODUTOS */}
      {modalAberta && (
        <div 
          class="modal" 
          style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}
          onClick={(e) => e.target === e.currentTarget && fecharModal()}
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title montserrat verde bold">
                  Produtos do Pedido {pedidoSelecionado}
                </h5>
                <button 
                  type="button" 
                  class="btn-close" 
                  onClick={fecharModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {carregandoProdutos ? (
                  <div class="text-center p-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Carregando produtos...</span>
                    </div>
                    <div class="mt-2 montserrat">Carregando produtos...</div>
                  </div>
                ) : produtosPedido.length === 0 ? (
                  <div class="text-center p-4">
                    <div class="montserrat">Nenhum produto encontrado para este pedido.</div>
                  </div>
                ) : (
                  <div>
                    {produtosPedido.map((produto, index) => (
                      <div key={index} class="mb-3 border-bottom pb-3">
                        <PrecoPictureQuantidadeFranqueado 
                          dsc={produto[0]} 
                          img={produto[1]} 
                          qnt={produto[2]} 
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div class="modal-footer">
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  onClick={fecharModal}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>    
  )
}


export default PedidosLoja;